module.exports = __webpack_public_path__ + "img/apenair.33e316e0.png";